<template>
  <Modal v-if="show" :no-spacing="true" name="success-modal" :hide-header="true" @close="closeModal">
    <div slot="body" class="success-modal-container">
      <div class="icon-wrapper">
        <img :src="publicUrl + '/success-tick.svg'" alt="" />
      </div>
      <div class="modal-success-message">{{ message }}</div>
      <div @click="closeModal">
        <ButtonComponent class="btn btn-secondary">
          {{ closeLabel }}
        </ButtonComponent>
      </div>
    </div>
  </Modal>
</template>

<script>
  /* eslint-disable vue/require-default-prop */

  import Modal from "./modal.vue"

  export default {
    name: "SuccessModal",
    components: {
      Modal
    },
    props: {
      show: {
        type: Boolean
      },
      message: {
        type: String
      },
      closeLabel: {
        type: String
      }
    },
    data() {
      return {
        publicUrl: process.env.PUBLIC_URL
      }
    },
    methods: {
      closeModal() {
        this.$emit("close-modal")
      }
    }
  }
</script>
<style lang="scss" scoped>
  .success-modal-container {
    text-align: center;
    padding: 16px;
    .icon-wrapper img {
      height: 160px;
      width: 160px;
      margin-bottom: 20px;
    }
    .modal-success-message {
      font-size: 20px;
      color: #212121;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .modal-close-btn {
      border: 2px solid #1ba26f;
      background-color: #edf8f4;
      border-radius: 6px;
      color: #1ba26f;
      font-size: 16px;
      padding: 12px;
    }
  }
</style>
